import React, { useState } from 'react';
import { Moon, Sun, Search, X, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from './ThemeContext';

const CATEGORY_LABELS = {
  tr: {
    kahvaltı: "Kahvaltı",
    tost_çeşitleri: "Tost",
    salata_çeşitleri: "Salatalar",
    makarna_çeşitleri: "Makarna",
    atıştırmalıklar: "Atıştırmalıklar",
    meşrubatlar: "Meşrubatlar",
    sıcak_içecekler: "Sıcak İçecekler",
    kokteyl_çeşitleri: "Kokteyller",
    bira_çeşitleri: "Biralar",
  },
  en: {
    kahvaltı: "Breakfast",
    tost_çeşitleri: "Toast",
    salata_çeşitleri: "Salads",
    makarna_çeşitleri: "Pasta",
    atıştırmalıklar: "Snacks",
    meşrubatlar: "Beverages",
    sıcak_içecekler: "Hot Drinks",
    kokteyl_çeşitleri: "Cocktails",
    bira_çeşitleri: "Beers",
  }
};

const menuData = {
  kahvaltı: [
    {
      name: "Special Kahvaltı (Kişi Başı)", nameEn: "Special Breakfast (Per Person)", price: 580,
      description: "Peynir çeşitleri, zeytin, domates, salatalık, bal, tereyağı ve sınırsız çay dahil",
      descriptionEn: "Assorted cheeses, olives, tomato, cucumber, honey, butter & unlimited tea"
    }
  ],
  tost_çeşitleri: [
    { name: "Kaşarlı Domatesli", nameEn: "Cheese & Tomato Toast", price: 260 },
    { name: "Kaşarlı Sucuklu", nameEn: "Cheese & Sausage Toast", price: 400 },
    {
      name: "Selçuk Usulü Tost", nameEn: "Selçuk Style Toast", price: 400,
      description: "Kaşar, sucuk, domates ve özel sos",
      descriptionEn: "Cheddar, sausage, tomato & house sauce"
    },
    {
      name: "Akdeniz Sandviç", nameEn: "Mediterranean Sandwich", price: 450,
      description: "Taze sebzeler, beyaz peynir ve zeytin",
      descriptionEn: "Fresh vegetables, white cheese & olives"
    },
    { name: "Tahıl Ekmekli Beyaz Peynirli Sandviç", nameEn: "Grain Bread White Cheese Sandwich", price: 450 },
    { name: "Ton Balıklı Sandviç", nameEn: "Tuna Sandwich", price: 490 },
  ],
  salata_çeşitleri: [
    {
      name: "Çoban Salata", nameEn: "Shepherd's Salad", price: 400,
      description: "Domates, salatalık, biber, maydanoz, limon",
      descriptionEn: "Tomato, cucumber, pepper, parsley, lemon"
    },
    {
      name: "Greek Salata", nameEn: "Greek Salad", price: 450,
      description: "Beyaz peynir, siyah zeytin, domates, salatalık",
      descriptionEn: "Feta, black olives, tomato, cucumber"
    },
    { name: "Mevsim Salata", nameEn: "Seasonal Salad", price: 400 },
    {
      name: "Tavuk Sezar Salata", nameEn: "Chicken Caesar Salad", price: 550,
      description: "Izgara tavuk, parmesan, kruton, sezar sos",
      descriptionEn: "Grilled chicken, parmesan, croutons, caesar dressing"
    },
    { name: "Ton Balıklı Salata", nameEn: "Tuna Salad", price: 550 },
  ],
  makarna_çeşitleri: [
    {
      name: "Penne Arabiata", nameEn: "Penne Arrabiata", price: 400,
      description: "Acılı domates sos", descriptionEn: "Spicy tomato sauce"
    },
    {
      name: "Spagetti Bolognez", nameEn: "Spaghetti Bolognese", price: 550,
      description: "Kıymalı et sosu", descriptionEn: "Ground beef meat sauce"
    },
    {
      name: "Spagetti Napoliten", nameEn: "Spaghetti Napolitan", price: 400,
      description: "Taze domates sosu", descriptionEn: "Fresh tomato sauce"
    },
    {
      name: "Tavuklu Tagliatelle", nameEn: "Chicken Tagliatelle", price: 550,
      description: "Izgara tavuk, krema sos", descriptionEn: "Grilled chicken, cream sauce"
    },
  ],
  atıştırmalıklar: [
    { name: "Hamburger", nameEn: "Hamburger", price: 480 },
    { name: "Cheeseburger", nameEn: "Cheeseburger", price: 540 },
    {
      name: "Yonca Burger", nameEn: "Yonca Burger", price: 770,
      description: "Özel sos, cheddar, soğan halkası ve domates",
      descriptionEn: "Special sauce, cheddar, onion rings & tomato"
    },
    {
      name: "Annem Köfte (Kırmızı Et)", nameEn: "Mom's Meatballs (Red Meat)", price: 700,
      description: "Patates kızartması ile servis edilir",
      descriptionEn: "Served with french fries"
    },
    {
      name: "Babam Köfte (Beyaz Et)", nameEn: "Dad's Meatballs (White Meat)", price: null,
      description: "Patates kızartması ile servis edilir",
      descriptionEn: "Served with french fries"
    },
    { name: "Çöp Şiş", nameEn: "Meat Skewers", price: 750 },
    { name: "Tavuk Şiş", nameEn: "Chicken Skewers", price: 590 },
    { name: "Tavuk Şinitzel", nameEn: "Chicken Schnitzel", price: 650 },
    { name: "Tavuk Burrito", nameEn: "Chicken Burrito", price: 450 },
    { name: "Et Burrito", nameEn: "Meat Burrito", price: 590 },
    {
      name: "Yonca Bira Sepetim", nameEn: "Yonca Beer Basket", price: 570,
      description: "Çıtır parmak patates ve soğan halkası",
      descriptionEn: "Crispy fries & onion rings"
    },
    { name: "Patates Kızartması", nameEn: "French Fries", price: 300 },
    { name: "Balık Ekmek", nameEn: "Fish Sandwich", price: 400 },
    { name: "Sigara Böreği", nameEn: "Fried Cheese Rolls", price: 300 },
  ],
  meşrubatlar: [
    { name: "Coca Cola", nameEn: "Coca Cola", price: 110 },
    { name: "Coca Cola Zero", nameEn: "Coca Cola Zero", price: 110 },
    { name: "Fanta", nameEn: "Fanta", price: 110 },
    { name: "Sprite", nameEn: "Sprite", price: 110 },
    {
      name: "Frutti Ekstra", nameEn: "Frutti Extra", price: 110,
      description: "Orman Meyveli · Yeşil Limonlu · Kavunlu",
      descriptionEn: "Forest Berry · Lime · Melon"
    },
    {
      name: "Meyveli Soda", nameEn: "Fruit Soda", price: 70,
      description: "Limon · Elma · Karpuz · Çilek",
      descriptionEn: "Lemon · Apple · Watermelon · Strawberry"
    },
    { name: "Uludağ Efsane Gazoz", nameEn: "Uludag Legendary Soda", price: 110 },
    { name: "Uludağ Soda", nameEn: "Uludag Soda", price: 60 },
    { name: "Uludağ Limonata", nameEn: "Uludag Lemonade", price: 110 },
    { name: "Frappe", nameEn: "Frappe", price: 300 },
    {
      name: "Milkshake (Çikolatalı / Çilekli)", nameEn: "Milkshake (Chocolate / Strawberry)", price: 300
    },
    {
      name: "Meyveli Frozen (Kavunlu / Karpuzlu)", nameEn: "Fruit Frozen (Melon / Watermelon)", price: 300
    },
    { name: "Ayran", nameEn: "Ayran", price: 80 },
    { name: "Churchill", nameEn: "Churchill", price: 110 },
    { name: "Küçük Su", nameEn: "Small Water", price: 30 },
    { name: "Büyük Su", nameEn: "Large Water", price: 60 },
  ],
  sıcak_içecekler: [
    { name: "Çay", nameEn: "Tea", price: 60 },
    { name: "Türk Kahvesi", nameEn: "Turkish Coffee", price: 150 },
    { name: "Espresso", nameEn: "Espresso", price: 150 },
    { name: "Cafe Latte / Cappuccino", nameEn: "Cafe Latte / Cappuccino", price: 180 },
    { name: "Sıcak Çikolata", nameEn: "Hot Chocolate", price: 200 },
    { name: "Filtre Kahve", nameEn: "Filter Coffee", price: 200 },
    { name: "Ice Americano", nameEn: "Iced Americano", price: 200 },
  ],
  kokteyl_çeşitleri: [
    { name: "Cin Tonik", nameEn: "Gin & Tonic", price: 700 },
    { name: "Margarita", nameEn: "Margarita", price: 750 },
    { name: "Mojito", nameEn: "Mojito", price: 750 },
    { name: "Long Island", nameEn: "Long Island Iced Tea", price: 800 },
  ],
  bira_çeşitleri: [
    { name: "Tuborg Gold", nameEn: "Tuborg Gold", price: 250 },
    { name: "Carlsberg", nameEn: "Carlsberg", price: 280 },
    { name: "Carlsberg Luna", nameEn: "Carlsberg Luna", price: 280 },
    { name: "Amber (Tuborg Filtresiz)", nameEn: "Amber – Tuborg Unfiltered", price: null },
    { name: "Frederic Marzen", nameEn: "Frederic Märzen", price: 350 },
    { name: "Wheat IPA", nameEn: "Wheat IPA", price: null },
    { name: "Brown Ale", nameEn: "Brown Ale", price: null },
    { name: "Local Yakıma IPA", nameEn: "Local Yakima IPA", price: null },
    { name: "Sol", nameEn: "Sol", price: 350 },
    { name: "Desperados", nameEn: "Desperados", price: 350 },
    { name: "Blanc", nameEn: "Blanc", price: 350 },
    { name: "India", nameEn: "India", price: null },
  ],
};

const QRMenu = () => {
  const { isDark, toggleDark } = useTheme();
  const [selectedCategory, setSelectedCategory] = useState('kahvaltı');
  const [language, setLanguage] = useState('tr');
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();

  const catLabel = (cat) => CATEGORY_LABELS[language][cat] || cat;

  const searchResults = searchQuery.trim()
    ? Object.entries(menuData).reduce((acc, [cat, items]) => {
      const q = searchQuery.toLowerCase();
      const matched = items.filter(item =>
        item.name.toLowerCase().includes(q) ||
        item.nameEn.toLowerCase().includes(q) ||
        (item.description || '').toLowerCase().includes(q) ||
        (item.descriptionEn || '').toLowerCase().includes(q)
      );
      if (matched.length > 0) acc.push({ cat, items: matched });
      return acc;
    }, [])
    : null;

  const isSearching = searchQuery.trim().length > 0;
  const totalResults = searchResults ? searchResults.reduce((s, g) => s + g.items.length, 0) : 0;
  const displayGroups = isSearching
    ? searchResults
    : [{ cat: selectedCategory, items: menuData[selectedCategory] || [] }];

  const priceLabel = (price) =>
    price != null ? `${price} ₺` : (language === 'tr' ? 'Sorunuz' : 'Ask staff');

  return (
    <div className="min-h-screen bg-stone-50 dark:bg-neutral-950 transition-colors duration-300">

      {/* Header */}
      <div className="relative">
        <img
          src={process.env.PUBLIC_URL + '/background.png'}
          alt="Yonca Beach"
          className="w-full h-full object-cover object-center"
        />
        {isDark && <div className="absolute inset-0 bg-black/30" />}
      </div>

      {/* Sticky nav */}
      <div className="sticky top-0 z-20 bg-white/95 dark:bg-neutral-950/95 backdrop-blur-md border-b border-stone-200 dark:border-neutral-800 transition-colors duration-300">

        {/* Search + controls */}
        <div className="flex items-center gap-2 px-3 pt-3 pb-2">
          <div className="flex-1 flex items-center gap-2 bg-stone-100 dark:bg-neutral-800 rounded-xl px-3 py-2.5 transition-colors">
            <Search className="w-4 h-4 text-stone-400 dark:text-neutral-500 flex-shrink-0" />
            <input
              type="text"
              placeholder={language === 'tr' ? 'Ürün ara...' : 'Search menu...'}
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              className="flex-1 bg-transparent text-sm text-stone-700 dark:text-neutral-200 placeholder-stone-400 dark:placeholder-neutral-500 outline-none min-w-0"
            />
            {searchQuery && (
              <button onClick={() => setSearchQuery('')} className="flex-shrink-0">
                <X className="w-4 h-4 text-stone-400 dark:text-neutral-500" />
              </button>
            )}
          </div>
          <button
            onClick={() => setLanguage(l => l === 'tr' ? 'en' : 'tr')}
            className="px-3 py-2.5 rounded-xl bg-stone-100 dark:bg-neutral-800 text-xs font-bold text-stone-600 dark:text-neutral-300 hover:bg-stone-200 dark:hover:bg-neutral-700 transition-colors flex-shrink-0"
          >
            {language === 'tr' ? 'EN' : 'TR'}
          </button>
          <button
            onClick={toggleDark}
            className="p-2.5 rounded-xl bg-stone-100 dark:bg-neutral-800 text-stone-600 dark:text-neutral-300 hover:bg-stone-200 dark:hover:bg-neutral-700 transition-colors flex-shrink-0"
          >
            {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </button>
        </div>

        {/* Category tabs */}
        {!isSearching && (
          <div className="overflow-x-auto scrollbar-hide">
            <div className="flex gap-1.5 px-3 pb-3 min-w-max">
              {Object.keys(menuData).map(cat => (
                <button
                  key={cat}
                  onClick={() => setSelectedCategory(cat)}
                  className={`px-3.5 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap transition-all ${selectedCategory === cat
                    ? 'bg-teal-500 text-white shadow-sm'
                    : 'bg-stone-100 dark:bg-neutral-800 text-stone-600 dark:text-neutral-400 hover:bg-stone-200 dark:hover:bg-neutral-700'
                    }`}
                >
                  {catLabel(cat)}
                </button>
              ))}
              <button
                onClick={() => navigate('/aksam')}
                className="px-3.5 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap bg-amber-100 dark:bg-amber-900/30 text-amber-700 dark:text-amber-400 hover:bg-amber-200 dark:hover:bg-amber-900/50 transition-all flex items-center gap-1"
              >
                {language === 'tr' ? 'Akşam Menüsü' : 'Evening Menu'}
                <ArrowRight className="w-3 h-3" />
              </button>
            </div>
          </div>
        )}

        {isSearching && (
          <div className="px-4 pb-3">
            <span className="text-xs text-stone-400 dark:text-neutral-500">
              {language === 'tr'
                ? `${totalResults} ürün bulundu`
                : `${totalResults} item${totalResults !== 1 ? 's' : ''} found`}
            </span>
          </div>
        )}
      </div>

      {/* Menu content */}
      <div className="px-4 py-5 space-y-3 max-w-2xl mx-auto">
        {displayGroups.length === 0 ? (
          <div className="text-center py-20">
            <Search className="w-10 h-10 mx-auto mb-3 text-stone-300 dark:text-neutral-700" />
            <p className="text-sm text-stone-400 dark:text-neutral-500">
              {language === 'tr' ? 'Ürün bulunamadı' : 'No items found'}
            </p>
          </div>
        ) : (
          displayGroups.map(({ cat, items }) => (
            <div key={cat} className="bg-white dark:bg-neutral-900 rounded-2xl overflow-hidden shadow-sm border border-stone-100 dark:border-neutral-800 transition-colors duration-300">
              {isSearching && (
                <div className="px-4 pt-4 pb-1">
                  <span className="text-xs font-bold text-teal-600 dark:text-teal-400 uppercase tracking-widest">
                    {catLabel(cat)}
                  </span>
                </div>
              )}
              <div className="divide-y divide-stone-100 dark:divide-neutral-800">
                {items.map((item, idx) => (
                  <div key={idx} className="px-4 py-4">
                    <div className="flex justify-between items-start gap-3">
                      <div className="flex-1 min-w-0">
                        <p className="font-semibold text-stone-800 dark:text-neutral-100 text-sm leading-snug">
                          {language === 'tr' ? item.name : item.nameEn}
                        </p>
                        {language === 'tr' && item.nameEn && (
                          <p className="text-xs text-stone-400 dark:text-neutral-500 mt-0.5 italic">
                            {item.nameEn}
                          </p>
                        )}
                        {(item.description || item.descriptionEn) && (
                          <p className="text-xs text-stone-500 dark:text-neutral-400 mt-1.5 leading-relaxed">
                            {language === 'tr'
                              ? item.description
                              : (item.descriptionEn || item.description)}
                          </p>
                        )}
                      </div>
                      <span className={`font-bold text-sm flex-shrink-0 mt-0.5 ${item.price != null
                        ? 'text-teal-600 dark:text-teal-400'
                        : 'text-stone-400 dark:text-neutral-600 text-xs font-medium'
                        }`}>
                        {priceLabel(item.price)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>

      {/* Footer */}
      <div className="px-4 pt-2 pb-10 text-center">
        <p className="text-xs text-stone-300 dark:text-neutral-700">
          Yonca Beach & Restaurant &mdash; {language === 'tr' ? 'Afiyet olsun!' : 'Enjoy your meal!'}
        </p>
      </div>
    </div>
  );
};

export default QRMenu;
